"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade["default"];
  }
});
var _Fade = _interopRequireDefault(require("react-bootstrap/lib/Fade"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Fade.js
// module id = 6396
// module chunks = 25